/**
 * 浏览器信息
 * @type {Object}
 * @return {Boolean}  返回布尔值
 */
function UA() {
    var u = navigator.userAgent.toLowerCase();
    return {
        isWeibo: u.match(/weibo/i) == "weibo",
        isWeixin: u.match(/micromessenger/i) == "micromessenger",
        isAndroid: u.match(/android/i) == "android",
        isIphone: u.match(/iphone/i) == "iphone",
        isQq: u.match(/qq/i) == "qq",
        isQzone: u.match(/qzone/i) == "qzone",
        isBaiDu: u.match(/baidu/i) == "baidu",
    };
}

import {createApp, h} from "vue";

export default {
    install(app) {

        app.$data = {
            isAndroid: UA().isAndroid,
            isIphone: UA().isIphone,

            wxDownLink: "http://a.app.qq.com/o/simple.jsp?pkgname=com.renting",
            iosDownLink: "https://itunes.apple.com/app/id1323479370?mt=8",
            androidDownLink:
                "https://www.wellcee.com/api/tools/androidDownloadUrl",
        };

        // 下载APP
        app.config.globalProperties.$downloadApp = function (page, params) {
            if (UA().isWeixin) {
                // wx
                app.$wxDownloadAppTip();
            } else {
                // 下载APP
                if (UA().isAndroid) {
                    // android
                    window.location.href = app.$data.androidDownLink;
                } else if (UA().isIphone) {
                    //iphone
                    window.location.href = app.$data.iosDownLink;
                }
            }
        };

        // 微信下载APP提示
        app.$wxDownloadAppTip = function () {
            // 只允许一个存在
            if (document.getElementsByClassName("wx-download-app-tip").length) {
                return;
            }

            let downloadVM = createApp({
                setup() {
                    return () =>
                        h("img", {
                            src: app.$data.isAndroid
                                ? "https://qnimg1.wellcee.com/android-default.png"
                                : "https://qnimg1.wellcee.com/ios-default.png",
                        });
                },
            });
            let downloadWrapper = document.createElement("div");
            downloadWrapper.className = "wx-download-app-tip";
            downloadWrapper.id = "wx-download-app-tip";
            document.body.appendChild(downloadWrapper);
            downloadVM.mount("#wx-download-app-tip");
        };
    },
};
